import React from "react";
import { Route, Redirect } from "react-router-dom";

import { Subscribe, AuthContainer } from "./state";

const AuthRoute = ({ component: Component, ...rest }) => (
  <Subscribe to={[AuthContainer]}>
    {(auth) => {
      const render = (props) => {
        const redirectTo = {
          pathname: "/login",
          state: { from: props.location },
        };
        if (auth.hasAuth()) {
          return <Component {...props} />;
        } else {
          return <Redirect to={redirectTo} />;
        }
      };

      return <Route {...rest} render={render} />;
    }}
  </Subscribe>
);

class RouterErrorBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // FIXME: logErrorToMyErrorReportingServicePlease(error, info)
    console.log({ error, info });
  }
  handleReloadClick = () => {
    window.document.location.reload(true);
  };
  render() {
    if (this.state.hasError) {
      return (
        <p>
          Something went wrong.{" "}
          <button onClick={this.handleReloadClick}>Reload the page</button>
        </p>
      );
    }
    return this.props.children;
  }
}

export { AuthRoute, RouterErrorBoundary };

export { HashRouter as Router, Switch, Route } from "react-router-dom";
export { withRouter } from "react-router-dom";
export { Link, NavLink, Redirect } from "react-router-dom";
